import { TypeAccessType, TypeUserType, ICurrentUser } from '@/interfaces/user';
import {
  USER_TYPE_OTHER,
  ACCESS_TYPE_CLIENT,
  USER_TYPE_DOCTOR,
} from '@/settings/consts/users';

export default class CurrentUserModel {
  public id: string;
  public idUsuario: string;
  public idMedico: string;
  public nome: string;
  public email: string;
  public cpf: string;
  public crm: string;
  public crmUF: string;
  public telefone: string;
  public celular: string;
  public tipoAcesso: TypeAccessType;
  public tipoLogin: TypeUserType;
  public senha: string;
  public novaSenha: string;
  public novaSenhaConfirma: string;

  constructor(_initialValues?: ICurrentUser) {
    const initialValues = _initialValues || {
      id: null,
      idUsuario: null,
      idMedico: null,
      nome: '',
      email: '',
      cpf: '',
      crm: '',
      crmUF: '',
      telefone: '',
      celular: '',
      tipoAcesso: ACCESS_TYPE_CLIENT,
      tipoLogin: USER_TYPE_OTHER,
      senha: '',
      novaSenha: '',
      novaSenhaConfirma: '',
    };

    this.id = initialValues.id;
    this.idUsuario = initialValues.idUsuario;
    this.idMedico = initialValues.idMedico;
    this.nome = initialValues.nome;
    this.email = initialValues.email;
    this.cpf = initialValues.cpf;
    this.crm = initialValues.crm;
    this.crmUF = initialValues.crmUF;
    this.telefone = initialValues.telefone;
    this.celular = initialValues.celular;
    this.tipoAcesso = initialValues.tipoAcesso;
    this.tipoLogin = initialValues.tipoLogin;
    this.senha = '';
    this.novaSenha = '';
    this.novaSenhaConfirma = '';
  }

  public validate(): boolean {
    const validatePassword = () =>
      !this.senha || this.novaSenha === this.novaSenhaConfirma;

    const validateName = () =>
      this.tipoLogin === USER_TYPE_DOCTOR || !!this.nome;

    return validatePassword() && validateName() && !!this.email;
  }

  public toJson(): any {
    const payload = {
      idLogin: this.id,
      usuario: null,
      medico: null,
      senhaAtual: null,
      senhaNova: null,
      confirmacao: null,
    };

    if (this.tipoLogin === USER_TYPE_DOCTOR) {
      payload.medico = {
        id: this.idMedico,
        email: this.email,
        telefone: this.telefone,
        celular: this.celular,
      };
    } else {
      payload.usuario = {
        id: this.idUsuario,
        nome: this.nome,
        email: this.email,
      };
    }

    if (!!this.senha && !!this.novaSenha && !!this.novaSenhaConfirma) {
      payload.senhaAtual = this.senha;
      payload.senhaNova = this.novaSenha;
      payload.confirmacao = this.novaSenhaConfirma;
    }

    return payload;
  }
}
